import Trustpilot from '../mixins/Trustpilot.js';
import Base from './Base.js';

export default class GamblingOperator extends Trustpilot(Base) {
}